export const capitalizeWords = name => name.trim().split(' ').map(char => char.charAt(0).toUpperCase() + char.substring(1).toLowerCase()).join(' ')
